// extracted by mini-css-extract-plugin
export var footerContainer = "L_cn";
export var footerContent = "L_cq";
export var footerDisclosure = "L_cr";
export var menu = "L_cp";